export default __webpack_public_path__ + "static/media/solution_05.27733aa1.png";